var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-tabs',{attrs:{"is-reg-active":_vm.isRegisterActive},on:{"setIsRegisterActive":function($event){_vm.isRegisterActive = $event}}}),_vm._v(" "),_c('tab-panes',{attrs:{"is-reg-active":_vm.isRegisterActive}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }